import * as React from 'react';
import { signIn } from 'next-auth/client';
import { StoreContext } from '../utils';
import { Store } from '../store/Store';

export class SigninButtonEmail extends React.Component {
  static contextType = StoreContext;
  declare context: Store;

  get buttonText() {
    if (this.context.requestStore.requestLocation.pathurl.includes('signin')) {
      return 'Weiter mit E-Mail';
    }
    return 'Anmelden mit E-Mail';
  }

  render() {
    const {} = this.context;

    return (
      <a href="/auth/email" className="btn btn-light-primary font-weight-bolder px-8 py-4 my-3 font-size-lg">
        <span className="svg-icon svg-icon-md">
          {/*begin::Svg Icon | path:assets/media/svg/social-icons/google.svg*/}
          <i className="far fa-envelope-open"></i>
          {/*end::Svg Icon*/}
        </span>
        {this.buttonText}
      </a>
    );
  }
}
